// Mock data for Suisse Energies Renouvelables (frontend-only data layer)
export const COMPANY = {
  name: "Suisse Energies Renouvelables",
  short: "SER",
  address: "Route d'Hermance 517, 1248 Hermance (GE)",
  email: "contact@suisse-energies-renouvelables.ch",
  phone: "022 518 71 55",
  phoneIntl: "+41225187155",
  cantons: ["Genève", "Vaud", "Valais", "Neuchâtel", "Fribourg", "Berne", "Jura"],
  socials: {
    facebook: "https://www.facebook.com/profile.php?id=61590445664657",
    instagram: "https://www.instagram.com/suisse.energies.renouvelables/",
    linkedin: "https://www.linkedin.com/company/suisse-energies-renouvelables/",
  },
  legal: {
    mentionsLegales: "/docs/mentions-legales.pdf",
    politique: "/docs/confidentialite-cookies.pdf",
    cgv: "/docs/cgv.pdf",
  },
};

export const SOLUTIONS = [
  {
    slug: "panneaux-solaires",
    eyebrow: "PRODUISEZ VOTRE PROPRE ÉLECTRICITÉ SOLAIRE",
    title: "Panneaux photovoltaïques",
    short: "Production d'électricité renouvelable pour votre autoconsommation",
    image: "/photos/panneaux-solaires.jpg",
    image2: "/photos/panneaux-solaires-2.jpg",
    icon: "Sun",
    description:
      "Les panneaux photovoltaïques transforment le rayonnement solaire en électricité au moyen de cellules à base de silicium. L'énergie générée est prioritairement utilisée sur site dans une logique d'autoconsommation, tandis que le surplus peut être injecté dans le réseau électrique.",
    benefits: [
      "Réduction des factures",
      "Indépendance énergétique",
      "Énergie propre et locale",
      "Plus-value du bien immobilier",
      "0 émission de CO₂",
      "Éligibles aux subventions",
    ],
  },
  {
    slug: "pompes-a-chaleur",
    eyebrow: "LE CHAUFFAGE PERFORMANT ET SILENCIEUX",
    title: "Pompes à chaleur",
    short: "Chauffage performant et économique pour votre habitat",
    image: "/photos/pompe-a-chaleur.jpg",
    image2: "/photos/pompe-a-chaleur-2.jpg",
    icon: "Thermometer",
    description:
      "Une pompe à chaleur (PAC) capte les calories présentes dans l'air, le sol ou l'eau et les remonte à une température utile pour chauffer le logement et produire l'eau chaude sanitaire. Rendement élevé : pour 1 kWh consommé, elle peut restituer plusieurs kWh de chaleur.",
    benefits: [
      "Réduction des coûts de chauffage",
      "Mode de chauffage écologique",
      "Confort thermique stable",
      "Économies d'énergie importantes",
      "Éligibles aux subventions",
      "Valorisation du bien immobilier",
    ],
  },
  {
    slug: "batteries-stockage",
    eyebrow: "L'AUTONOMIE 24H/24",
    title: "Batteries de stockage",
    short: "Stockez votre énergie pour une autonomie maximale",
    image: "/photos/batterie-2.jpg",
    image2: "/photos/batterie.avif",
    icon: "BatteryCharging",
    description:
      "Une batterie de stockage conserve l'électricité produite par vos panneaux solaires en journée afin de l'utiliser plus tard, notamment en soirée. Un système intelligent pilote les phases de charge et de décharge en fonction de votre production solaire et de votre consommation.",
    benefits: [
      "Autoconsommation maximisée",
      "Réduction des factures",
      "Rentabilité de l'installation solaire",
      "Indépendance énergétique accrue",
      "Solution évolutive & intelligente",
      "Sécurité de l'approvisionnement",
    ],
  },
  {
    slug: "boilers-thermodynamiques",
    eyebrow: "L'EAU CHAUDE SANITAIRE INTELLIGENTE",
    title: "Boilers thermodynamiques",
    short: "Eau chaude sanitaire à haute efficacité énergétique",
    image: "/photos/boiler.webp",
    image2: "/photos/boiler.webp",
    icon: "Droplets",
    description:
      "Le boiler thermodynamique combine un ballon d'eau chaude et une mini pompe à chaleur intégrée. Il puise les calories dans l'air ambiant pour produire l'eau chaude sanitaire avec une efficacité énergétique 3 à 4 fois supérieure à un chauffe-eau classique.",
    benefits: [
      "Économies sur l'eau chaude",
      "Faible empreinte carbone",
      "Compatible photovoltaïque",
      "Installation simple",
      "Eligible aux aides",
      "Longue durée de vie",
    ],
  },
  {
    slug: "onduleurs",
    eyebrow: "LE CERVEAU DE L'INSTALLATION",
    title: "Onduleurs",
    short: "Conversion intelligente et sécurisée de votre énergie solaire",
    image: "/photos/onduleur.jpg",
    image2: "/photos/onduleur.jpg",
    icon: "Cpu",
    description:
      "L'onduleur convertit le courant continu (DC) produit par les panneaux en courant alternatif (AC) utilisable dans la maison. Il assure aussi le suivi de production, la sécurité et la communication avec batteries ou systèmes de pilotage.",
    benefits: [
      "Rend l'énergie solaire utilisable",
      "Optimisation des performances",
      "Sécurité renforcée",
      "Suivi précis de production",
      "Adaptabilité à chaque projet",
      "Compatible avec batteries",
    ],
  },
  {
    slug: "optimiseurs",
    eyebrow: "PRODUCTION MAXIMISÉE PAR PANNEAU",
    title: "Optimiseurs",
    short: "Optimisation panneau par panneau pour des rendements supérieurs",
    image: "/photos/optimiseurs.png",
    image2: "/photos/optimiseurs.png",
    icon: "Zap",
    description:
      "Les optimiseurs de puissance se placent au niveau de chaque panneau et ajustent leur fonctionnement pour limiter l'impact des ombrages, différences d'orientation ou salissures. Ils permettent un suivi détaillé par module.",
    benefits: [
      "Production maximisée panneau par panneau",
      "Idéal en cas d'ombrages",
      "Arrêt automatique en cas de panne",
      "Monitoring détaillé",
      "Durée de vie améliorée",
      "Adaptés aux toitures complexes",
    ],
  },
];

export const HERO_IMAGES = {
  home: "/photos/high-angle-solar.jpg",
  aboutLeft: "/photos/paysage.jpg",
  aboutRight: "/photos/paysage-2.jpg",
  paysage4: "/photos/paysage-4.jpg",
  panneaux3: "/photos/panneaux-solaires-3.jpg",
  pompe4: "/photos/pompe-a-chaleur-4.png",
  siege: "/photos/siege-hermance.png",
};

export const VALUES = [
  {
    title: "Fiabilité",
    text: "Notre engagement repose sur la qualité d'exécution de nos installations ainsi que le choix de solutions énergétiques fiables et performantes.",
  },
  {
    title: "Proximité",
    text: "Avec des experts présents dans toute la Suisse romande, nous garantissons un service de proximité efficace, répondant aux normes locales.",
  },
  {
    title: "Expertise",
    text: "Nos conseillers et experts énergétiques ont acquis une expérience de longue date dans l'installation de solutions techniques renouvelables.",
  },
];

export const STEPS = [
  { n: "01", title: "Analyse & objectifs", text: "Consommation actuelle, projets, contraintes, financement." },
  { n: "02", title: "Visite & étude technique", text: "Relevés, ombrages, structure, acoustique, hydraulique, dimensionnement." },
  { n: "03", title: "Démarches administratives", text: "Demandes d'autorisations, subventions et annonces aux gestionnaires de réseau." },
  { n: "04", title: "Préparation & installation", text: "Chantier planifié, sécurisé et contrôle qualité à chaque étape." },
  { n: "05", title: "Mise en service", text: "Paramétrage, test, vérification et explications d'utilisation au client." },
  { n: "06", title: "Suivi & après-vente", text: "SAV, conseils d'autoconsommation et monitoring systématiques." },
];

export const BENEFITS = [
  { title: "Économies d'énergie", text: "Produire son électricité solaire et adopter une pompe à chaleur permet de réduire ses coûts énergétiques tout en maîtrisant son budget." },
  { title: "Indépendance énergétique", text: "Vous gagnez en indépendance énergétique et vous n'êtes plus dépendant du réseau et de votre fournisseur d'électricité." },
  { title: "Plus-value du bien", text: "Votre rénovation énergétique vous permet d'améliorer l'étiquette verte de votre habitat ou de votre entreprise sur le marché immobilier." },
  { title: "Confort énergétique", text: "Une pompe à chaleur offre une température plus stable, une régulation plus fine et un confort thermique optimal toute l'année." },
  { title: "Subventions & aides", text: "Agir dès maintenant permet de profiter des subventions et des dispositifs d'aide fédéraux et cantonaux, réduisant l'investissement initial." },
  { title: "Éco-responsabilité", text: "En enclenchant votre transition énergétique, vous devenez éco-responsable et contribuez à la baisse des émissions de CO₂ du pays." },
];

export const STRENGTHS = [
  { title: "Un projet clé en main", text: "De l'étude énergétique jusqu'à la mise en service, nous gérons tout." },
  { title: "Des solutions fiables", text: "Des marques partenaires de renommée internationale sélectionnées avec soin." },
  { title: "Une expertise globale", text: "Solaire, pompe à chaleur, batterie, boiler : nous maîtrisons l'écosystème complet." },
  { title: "Un process interne", text: "100% géré en interne pour garantir délais, coûts et qualité." },
  { title: "Un partenaire de confiance", text: "Un interlocuteur unique pour vous accompagner à chaque étape." },
  { title: "Un ancrage local", text: "Siège à Hermance (GE), interventions dans toute la Suisse romande." },
];

export const PARTNERS = [
  { name: "Buderus", logo: "/partners/buderus.png", scale: 1.35 },
  { name: "Panasonic", logo: "/partners/panasonic.png", scale: 0.85 },
  { name: "Huawei", logo: "/partners/huawei.webp", scale: 1.4 },
  { name: "ATMOCE", logo: "/partners/atmoce.png", scale: 1.45 },
  { name: "DMEGC", logo: "/partners/dmegc.png", scale: 1.05 },
];
